import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Tooltip,
} from "@mui/material";
import { Box } from "@mui/system";
import axios from "axios";
import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from "react-redux";
import store from "../Store/index";
import AccordianContainer from "../CustomComponents/AccordianContainer";
import CustomAutoComplete from "../CustomComponents/CustomAutoComplete";
import CustomDateField from "../CustomComponents/CustomDateField";
import GetBranchDetails from "../CustomComponents/GetBranchDetails";
import GetBranchDetailsWithCode from "../CustomComponents/GetBranchDetailsWithCode";
import { FilePaymentReducerAction } from "../Store/FilePayment/FilePaymentReducer";
import { BranchAction } from "../Store/Branch";
import { SpecialAccessDetailAction } from "../Store/SpecialAccess/SpecialAccessDetailReducer";
import dayjs from "dayjs";
import { CommonShortCutAction } from "../Store/CommonShortCutsReducer";

const FilePaymentFilter = () => {
  const [mode, setMode] = useState();
  const [selectedData, setSelectedData] = useState();
  //Getting value from redux store
  const filterValue = useSelector((state) => state.filePayment.filterValues);

  const brachArrayWithCode = useSelector(
    (state) => state.filePayment.filterValues.brachArrayWithCode
  );
  const showGridComponent = useSelector(
    (state) => state.filePayment.HideComponents.showGridComponent
  );
  //Declaring dispatch
  const dispatch = useDispatch();

  //Getting Touch State
  const touchState = useSelector(
    (state) => state.filePayment.filterValueTouched
  );
  //Getting Valid State
  const validState = useSelector(
    (state) => state.filePayment.filterValueIsValid
  );
  //Getting store value for initial one row addition
  const filterValues = useSelector((state) => state.filePayment.filterValues);
  const userNames = useSelector((state) => state.branch.userName);
  const [userName, setUserName] = useState("");
  const [DialogOpen, setDialogOpen] = useState(false);
  const [cancelSelectedMode, setCancelSelectedMode] = useState();
  const [voucherDateError, setVoucherDateError] = useState(false);
  //Has Error
  const branchHasError = touchState.branchTouch && !validState.branchIsValid;
  const paymentTypeHasError =
    touchState.paymentTypeTouch && !validState.paymentTypeIsValid;
  const voucherDateHasError =
    touchState.voucherDateTouch && !validState.voucherDateIsValid;
  const fundTransferModeHasError =
    touchState.fundTransferModeIsTouched && !validState.fundTransferModeIsValid;
  const paymentBankHasError =
    touchState.paymentBankOrCashIsTouched &&
    !validState.paymentBankOrCashIsValid;
  const userId = store.getState().branch.userID;
  const moduleId = useSelector((state) => state.specialAccess.moduleId);
  const programId = useSelector((state) => state.specialAccess.programId);
  let fieldAccessMap = useSelector(
    (state) => state.specialAccess.fieldAccessMap
  );
  let paramValues = useSelector((state) => state.specialAccess.paramValues);

  //shortcut key
  const yesRef = useRef(null);
  const cancelRef = useRef(null);
  const clearRef = useRef(null);
  const searchButtonRef = useRef(null);

  useEffect(() => {
    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, []);
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "filePaymentFilter",
        })
      );
    }
  };
  const onKeyPressEventHandler = (event) => {
    let date = new Date();
    let charCode = String.fromCharCode(event.which).toLowerCase();
    if (event.key === "Escape" || event.keyCode === 27) {
      // on escape press close the dialog.
      onCancelButtonHandler();
    } else if (event.ctrlKey) {
      if (charCode === "y") {
        yesRef.current?.click();
      } else if (charCode === "q") {
        cancelRef.current?.click();
      } else if (charCode === "d") {
        clearRef.current.click();
      } else if (charCode === "f") {
        searchButtonRef.current.click();
      } else if (charCode === "o") {
        date.setDate(date.getDate() + 1);
        voucherDateOnChangeHandler(date);
      } else if (charCode === "i") {
        date = new Date();
        voucherDateOnChangeHandler(date);
      } else if (charCode === "p") {
        date.setDate(date.getDate() - 1);
        voucherDateOnChangeHandler(date);
      }
    }
  };
  //Branch onChangeHandler
  useEffect(() => {
    getFieldData();
  }, []);

  const getFieldData = async () => {
    let modeIdVal = "";
    const response = await axios.get("/specialAccess/getFieldAccess", {
      method: "get",
      params: {
        userId: userId,
        moduleId: moduleId,
        programId: programId,
        modeId: modeIdVal,
      },
    });
    dispatch(SpecialAccessDetailAction.getFieldData(response.data));
  };

  let minDateAddValue = Number(0);
  let maxDateAddValue = Number(0);

  if (
    paramValues !== null &&
    paramValues !== undefined &&
    Object.keys(paramValues).length > 0
  ) {
    if (
      !(
        paramValues["Payment Request Date Back Count"] &&
        new Date(
          paramValues["Payment Request Date Back Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Payment Request Date Back Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      minDateAddValue = 0;
    } else {
      minDateAddValue =
        fieldAccessMap.paymentCreateVoucherDate &&
        fieldAccessMap.paymentCreateVoucherDateBackCount
          ? Number(paramValues["Payment Request Date Back Count"]["paramValue"])
          : Number(0);
    }
    if (
      !(
        paramValues["Payment Request Date Future Count"] &&
        new Date(
          paramValues["Payment Request Date Future Count"]["paramEffStartDate"]
        ) <= new Date(dayjs(new Date()).format("MM/DD/YYYY")) &&
        new Date(
          paramValues["Payment Request Date Future Count"]["paramEffEndDate"]
        ) >= new Date(dayjs(new Date()).format("MM/DD/YYYY"))
      )
    ) {
      maxDateAddValue = 0;
    } else {
      maxDateAddValue =
        fieldAccessMap.paymentCreateVoucherDate &&
        fieldAccessMap.paymentCreateVoucherDateFutureCount
          ? Number(
              paramValues["Payment Request Date Future Count"]["paramValue"]
            )
          : Number(0);
    }
  }
  const branchOnChangeHandler = (value) => {
    setMode("BranchMode");
    setCancelSelectedMode("");

    setSelectedData(value);
    if (showGridComponent) {
      setDialogOpen(true);
    } else {
      dispatch(FilePaymentReducerAction.branchChangeResetHandler());
      dispatch(FilePaymentReducerAction.updateBranchValue(value));
      dispatch(FilePaymentReducerAction.updateRows([]));
      applicationNumberOnBranch(value);
      if (value !== "" || value !== null) {
        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(value.label));
      }
      if (value !== null) {
        const branchCode = brachArrayWithCode.find((branch) => {
          return value.label === branch.label;
        });
        dispatch(FilePaymentReducerAction.updateBranchCode(branchCode.code));
        getPaymentBank(branchCode.code);
      } else {
        dispatch(FilePaymentReducerAction.updatePaymentBankArray([]));
        dispatch(FilePaymentReducerAction.updateBranchCode(""));
      }
    }
  };

  //Fund transfer mode on change handler
  const fundTransferModeOnChangeHandler = (value) => {
    setMode("FundTransferMode");
    setCancelSelectedMode("");

    setSelectedData(value);
    if (showGridComponent) {
      setDialogOpen(true);
    } else {
      dispatch(FilePaymentReducerAction.updateFundTransferMode(value));
      dispatch(FilePaymentReducerAction.updateApplicationArray([]));
    }
  };
  const voucherDateOnChangeHandler = (value) => {
    setMode("VoucherDateMode");
    setCancelSelectedMode("VoucherCancelFlag");
    setSelectedData(value);
    if (showGridComponent) {
      setDialogOpen(true);
    } else {
      dispatch(FilePaymentReducerAction.updateVoucherDate(value));
    }
  };
  //Dialog open click
  const onOkButtonClickHandler = () => {
    dispatch(FilePaymentReducerAction.updateShowGridCompponent(false));
    if (mode === "BranchMode") {
      dispatch(FilePaymentReducerAction.updateRows([]));
      dispatch(FilePaymentReducerAction.branchChangeResetHandler());
      dispatch(FilePaymentReducerAction.updateBranchValue(selectedData));
      applicationNumberOnBranch(selectedData);
      if (selectedData !== null) {
        const branchCode = brachArrayWithCode.find((branch) => {
          return selectedData.label === branch.label;
        });
        dispatch(FilePaymentReducerAction.updateBranchCode(branchCode.code));
        getPaymentBank(branchCode.code);
      } else {
        dispatch(FilePaymentReducerAction.updatePaymentBankArray([]));
        dispatch(FilePaymentReducerAction.updateBranchCode(""));
      }
      if (selectedData !== "" || selectedData !== null) {
        dispatch(BranchAction.updateInitialLoad(false));
        dispatch(BranchAction.updateHeaderBranchDetails(selectedData.label));
      }
    }
    if (mode === "PaymentTypeMode") {
      dispatch(FilePaymentReducerAction.updatePaymentType(selectedData));
      dispatch(FilePaymentReducerAction.paymentTypeResetHandler());
      if (selectedData !== null) {
        const paymentTypeDescription = filterValue.paymentTypeWithDesArray.find(
          (data) => {
            return data.paymentType === selectedData ? data.paymentCode : "";
          }
        );
        dispatch(
          FilePaymentReducerAction.updatePaymentCode(
            paymentTypeDescription.paymentCode
          )
        );
      } else {
        dispatch(FilePaymentReducerAction.updatePaymentCode(""));
      }
    }
    if (mode === "FundTransferMode") {
      dispatch(FilePaymentReducerAction.updateApplicationArray([]));
      dispatch(FilePaymentReducerAction.updateFundTransferMode(selectedData));
    }
    if (mode === "PaymentBankorCash") {
      dispatch(FilePaymentReducerAction.updateApplicationArray([]));
      dispatch(FilePaymentReducerAction.updatePaymentBankValue(selectedData));
      // get the last selected data chnage on filter and update its bank code & branch key also.
      const paymentBankArrayValues =
        store.getState().filePayment.filterValues?.paymentBankArray;
      const selectedPaymentBanks = paymentBankArrayValues.filter(
        (obj) => obj.branch_name === selectedData
      );
      const selectedPaymentBank = selectedPaymentBanks[0];
      dispatch(
        FilePaymentReducerAction.updatepaymentBankCode(
          selectedPaymentBank ? selectedPaymentBank.gl_account : null
        )
      );
      dispatch(
        FilePaymentReducerAction.updatepaymentBankBranchKey(
          selectedPaymentBank ? selectedPaymentBank.bank_branch_key : null
        )
      );
    }
    if (mode === "VoucherDateMode") {
      dispatch(FilePaymentReducerAction.updateApplicationArray([]));
      dispatch(FilePaymentReducerAction.updateVoucherDate(selectedData));
    }
    if (mode === "SearchMode") {
      dispatch(FilePaymentReducerAction.updateGlDisplay(false));
      dispatch(FilePaymentReducerAction.updateApplicationDisplay(false));
      dispatch(FilePaymentReducerAction.updateRows([]));
      dispatch(FilePaymentReducerAction.updateApplicationArray([]));

      dispatch(
        FilePaymentReducerAction.addRows({
          id: Math.floor(Math.random() * 100),
          branch: filterValues.branchValue.label,
          branchCode: filterValues.branchCode,
          applicationBranchCode: filterValues.branchCode,
          applicationBranch: filterValues.branchValue.label,
          applicationNumber: "",
          glAccount: "",
          description: "",
          debitAmount: "",
          paymentBankOrCash: filterValues.paymentBankOrCash,
          paymentBankCode: filterValues.paymentBankCode,
          paymentBankBranchKey: filterValues.paymentBankBranchKey,
          fundTransferMode: filterValues.fundTransferMode,
          customerName: "",
          bankName: "",
          bankBranchName: "",
          ifsc: "",
          bankAccNum: "",
          emiAmt: "",
          emiStartDate: "",
          accountType: "",
          approvalFlg: false,
          // favourNameArray: [],
          //bankDetailArray: [],
          // favourName: "",
          paymentType: filterValues.paymentType,
          paymentCode: filterValues.paymentCode,
          voucherDate: filterValues.voucherDate,
          // depositBank: filterValues.depositBank,
          screenMode: "CREATE",
          createdBy: userName,
          lastModifiedBy: userName,
        })
      );
      dispatch(FilePaymentReducerAction.updateShowGridCompponent(false));
    }
    if (mode === "ClearButtonMode") {
      dispatch(FilePaymentReducerAction.updateBranchValue(null));
      dispatch(FilePaymentReducerAction.updatePaymentType(null));
      dispatch(FilePaymentReducerAction.updateFundTransferMode(null));
      dispatch(FilePaymentReducerAction.updateApplicationArray([]));
      dispatch(FilePaymentReducerAction.updatePaymentBankValue(null));
      dispatch(FilePaymentReducerAction.updatepaymentBankCode(null));
      dispatch(FilePaymentReducerAction.updatepaymentBankBranchKey(null));
      dispatch(FilePaymentReducerAction.updateVoucherDate(null));
      dispatch(FilePaymentReducerAction.updatePaymentBankArray([]));
      dispatch(FilePaymentReducerAction.updateBranchIsTouched(false));
      dispatch(FilePaymentReducerAction.updatePaymentTypeIsTouched(false));
      dispatch(FilePaymentReducerAction.updateFundTransferModeIsTouched(false));
      dispatch(
        FilePaymentReducerAction.updatePaymentBankOrCashIsTouched(false)
      );
      dispatch(FilePaymentReducerAction.updateVoucherDateIsTouched(false));
      setVoucherDateError(false);
    }
    setDialogOpen(false);
  };
  const onCancelButtonHandler = () => {
    if (cancelSelectedMode === "VoucherCancelFlag") {
      dispatch(
        FilePaymentReducerAction.updateVoucherDate(filterValue.voucherDate)
      );
      setDialogOpen(false);
    } else {
      setDialogOpen(false);
    }
  };
  //Filter Go button Handler
  const goButtonHandler = () => {
    setMode("SearchMode");
    dispatch(FilePaymentReducerAction.updateBranchIsTouched(true));
    dispatch(FilePaymentReducerAction.updatePaymentTypeIsTouched(true));
    dispatch(FilePaymentReducerAction.updateVoucherDateIsTouched(true));
    dispatch(FilePaymentReducerAction.updatePaymentBankOrCashIsTouched(true));
    let valid;
    if (filterValue.paymentType === "Fund Transfer") {
      dispatch(FilePaymentReducerAction.updateFundTransferModeIsTouched(true));
      valid =
        validState.branchIsValid &&
        //  validState.applicationIsValid &&
        validState.paymentTypeIsValid &&
        validState.voucherDateIsValid &&
        validState.paymentBankOrCashIsValid &&
        validState.fundTransferModeIsValid;
    } else {
      valid =
        validState.branchIsValid &&
        // validState.applicationIsValid &&
        validState.paymentTypeIsValid &&
        validState.paymentBankOrCashIsValid &&
        validState.voucherDateIsValid;
    }
    if (valid) {
      if (showGridComponent) {
        setDialogOpen(true);
      } else {
        dispatch(FilePaymentReducerAction.updateGlDisplay(false));
        dispatch(FilePaymentReducerAction.updateApplicationDisplay(false));
        dispatch(FilePaymentReducerAction.updateRows([]));
        dispatch(
          FilePaymentReducerAction.addRows({
            id: Math.floor(Math.random() * 100),
            branch: filterValues.branchValue.label,
            branchCode: filterValues.branchCode,
            applicationBranchCode: filterValues.branchCode,
            applicationBranch: filterValues.branchValue.label,
            applicationNumber: "",
            glAccount: "",
            description: "",
            debitAmount: "",
            paymentBankOrCash: filterValues.paymentBankOrCash,
            paymentBankCode: filterValues.paymentBankCode,
            paymentBankBranchKey: filterValues.paymentBankBranchKey,
            fundTransferMode: filterValues.fundTransferMode,
            customerName: "",
            bankName: "",
            bankBranchName: "",
            ifsc: "",
            bankAccNum: "",
            emiAmt: "",
            emiStartDate: "",
            accountType: "",
            approvalFlg: false,
            // favourNameArray: [],
            //bankDetailArray: [],
            // favourName: "",
            paymentType: filterValues.paymentType,
            paymentCode: filterValues.paymentCode,
            voucherDate: filterValues.voucherDate,
            // depositBank: filterValues.depositBank,
            screenMode: "CREATE",
            createdBy: userName,
            lastModifiedBy: userName,
          })
        );
        dispatch(FilePaymentReducerAction.updateShowGridCompponent(true));
      }
    }
  };
  const ClearButtonHandler = () => {
    setMode("ClearButtonMode");
    if (showGridComponent) {
      setDialogOpen(true);
    } else {
      dispatch(FilePaymentReducerAction.updateBranchValue(null));
      dispatch(FilePaymentReducerAction.updatePaymentType(null));
      dispatch(FilePaymentReducerAction.updateFundTransferMode(null));
      dispatch(FilePaymentReducerAction.updateApplicationArray([]));
      dispatch(FilePaymentReducerAction.updatePaymentBankValue(null));
      dispatch(FilePaymentReducerAction.updatepaymentBankCode(null));
      dispatch(FilePaymentReducerAction.updatepaymentBankBranchKey(null));
      dispatch(FilePaymentReducerAction.updateVoucherDate(null));
      dispatch(FilePaymentReducerAction.updatePaymentBankArray([]));
      dispatch(FilePaymentReducerAction.updateBranchIsTouched(false));
      dispatch(FilePaymentReducerAction.updatePaymentTypeIsTouched(false));
      dispatch(FilePaymentReducerAction.updateFundTransferModeIsTouched(false));
      dispatch(
        FilePaymentReducerAction.updatePaymentBankOrCashIsTouched(false)
      );
      dispatch(FilePaymentReducerAction.updateVoucherDateIsTouched(false));
      setVoucherDateError(false);
    }
  };
  //Payment Type on change
  const paymentTypeOnChangeHandler = (value) => {
    setMode("PaymentTypeMode");
    setCancelSelectedMode("");

    setSelectedData(value);
    if (showGridComponent) {
      setDialogOpen(true);
    } else {
      dispatch(FilePaymentReducerAction.updatePaymentType(value));
      dispatch(FilePaymentReducerAction.paymentTypeResetHandler());
      if (value !== null) {
        const paymentTypeDescription = filterValue.paymentTypeWithDesArray.find(
          (data) => {
            return data.paymentType === value ? data.paymentCode : "";
          }
        );
        dispatch(
          FilePaymentReducerAction.updatePaymentCode(
            paymentTypeDescription.paymentCode
          )
        );
      } else {
        dispatch(FilePaymentReducerAction.updatePaymentCode(""));
      }
    }
  };

  const paymentBankOrCashonChangeHandler = (value) => {
    setMode("PaymentBankorCash");
    setCancelSelectedMode("");

    setSelectedData(value);
    if (showGridComponent) {
      setDialogOpen(true);
    } else {
      dispatch(FilePaymentReducerAction.updatePaymentBankValue(value));
      // get the last selected data chnage on filter and update its bank code & branch key also.
      const paymentBankArrayValues =
        store.getState().filePayment.filterValues?.paymentBankArray;
      const selectedPaymentBanks = paymentBankArrayValues.filter(
        (obj) => obj.branch_name === value
      );
      const selectedPaymentBank = selectedPaymentBanks[0];
      dispatch(
        FilePaymentReducerAction.updatepaymentBankCode(
          selectedPaymentBank ? selectedPaymentBank.gl_account : null
        )
      );
      dispatch(
        FilePaymentReducerAction.updatepaymentBankBranchKey(
          selectedPaymentBank ? selectedPaymentBank.bank_branch_key : null
        )
      );
    }
  };

  const getSelectedBranchCode = (branchValue) => {
    const branchWithCodes = GetBranchDetailsWithCode();
    const branchCodeValue = branchWithCodes.find((branch) => {
      return branch.label === branchValue;
    });
    return branchCodeValue.code;
  };

  const applicationNumberOnBranch = async (value) => {
    try {
      const branchCodeValue = getSelectedBranchCode(value.label);
      const response = await axios.post("/filereceipt/getAppList", {
        branch: value.label,
        branchCode: branchCodeValue,
      });

      dispatch(
        FilePaymentReducerAction.updateFilterApplicationArray(
          response.data.sort()
        )
      );
    } catch {}
  };

  const getPaymentTypeData = async () => {
    try {
      const paymentLovValues = await axios.post("/lovMaster/getLovValues", {
        moduleId: "MD005",
      });
      const paymentTypeData = paymentLovValues.data["Payment Type"].map(
        (type) => {
          return {
            id: type.lovOrder,
            paymentCode: type.lovOrder,
            paymentType: type.lovValues,
          };
        }
      );
      dispatch(
        FilePaymentReducerAction.updatePaymentTypeWithDesArray(paymentTypeData)
      );
      const paymentTypeArray = paymentTypeData.map((payment) => {
        return payment.paymentType;
      });
      dispatch(
        FilePaymentReducerAction.updatePaymentTypeArray(paymentTypeArray)
      );
    } catch (e) {}
  };
  const getGlAccountBasedOnBranchCode = async (branchWithCode) => {
    const codes = branchWithCode.map((branches) => branches.code);
    const response = await axios.post("/filereceipt/getGLAccountDataByBranch", {
      shflApisModel: {
        apiCode: "FILE_GL_ACC_LOV_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
      },
      branchCodes: codes,
    });
    if (response.status === 200) {
      dispatch(
        FilePaymentReducerAction.updateAllBranchGlAccounts(response.data)
      );
    }
  };
  useEffect(() => {
    dispatch(FilePaymentReducerAction.resetHandler());
    const branchArr = GetBranchDetails();
    const branchWithCode = GetBranchDetailsWithCode();
    getGlAccountBasedOnBranchCode(branchWithCode);
    dispatch(FilePaymentReducerAction.updateBranchArray(branchArr));
    dispatch(FilePaymentReducerAction.updateBrachArrayWithCode(branchWithCode));

    getPaymentTypeData();

    const users = store.getState().branch.userName;
    setUserName(users);

    getFundTransferMode();
    return () => {
      dispatch(FilePaymentReducerAction.updateShowGridCompponent(false));
    };
  }, []);

  const getFundTransferMode = async () => {
    try {
      const response = await axios.post("/filepayment/getFundTransferType", {
        apiCode: "FUND_TRANSFER_LOV_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
      });
      if (response.data.message === "Success") {
        const fundTransferArray = response.data.fund_transfer_dtls.map(
          (data) => data.fund_desc
        );

        dispatch(
          FilePaymentReducerAction.updateFundTransferModeArray(
            fundTransferArray
          )
        );
      }
    } catch {}
  };

  const getPaymentBank = async (branchCode) => {
    try {
      const response = await axios.post("/filepayment/getPaymentBank", {
        apiCode: "BANK_CASH_ACCOUNT_API",
        createdBy: userNames,
        lastModifiedBy: userNames,
        branchCodes: branchCode,
      });
      if (response.data.message === "Success") {
        const paymentBankArray = response.data.ledger_details;
        dispatch(
          FilePaymentReducerAction.updatePaymentBankArray(paymentBankArray)
        );
      } else {
        dispatch(FilePaymentReducerAction.updatePaymentBankArray([]));
      }
    } catch {}
  };

  return (
    <>
      <Box>
        <AccordianContainer
          title="Refund Create"
          initialOpen={true}
          sx={{ margin: "8px !important" }}
        >
          <Box sx={{ marginTop: "-1%" }}>
            <Grid container rowSpacing={0} columnSpacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Branch"
                  label="Branch"
                  required={true}
                  autoCompleteValues={filterValue.branch}
                  value={
                    filterValue.branchValue ? filterValue.branchValue : null
                  }
                  onChange={(e, value) => {
                    branchOnChangeHandler(value);
                  }}
                  onBlur={() => {
                    dispatch(
                      FilePaymentReducerAction.updateBranchIsTouched(true)
                    );
                  }}
                />
                {branchHasError && (
                  <p className="error"> Please Select Branch</p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Payment Type"
                  label="Payment Type"
                  required={true}
                  autoCompleteValues={filterValue.paymentTypeArray}
                  value={filterValue.paymentType}
                  onChange={(e, value) => {
                    paymentTypeOnChangeHandler(value);
                  }}
                  onBlur={() => {
                    dispatch(
                      FilePaymentReducerAction.updatePaymentTypeIsTouched(true)
                    );
                  }}
                />
                {paymentTypeHasError && (
                  <p className="error"> Please Select Payment Type</p>
                )}
              </Grid>
              {filterValue.paymentType === "Fund Transfer" && (
                <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                  <CustomAutoComplete
                    variant="standard"
                    type="text"
                    placeholder="Select Fund Transfer Mode"
                    label="Fund Transfer Mode"
                    required={true}
                    autoCompleteValues={filterValue.fundTransferModeArray}
                    value={filterValue.fundTransferMode}
                    onChange={(e, value) => {
                      fundTransferModeOnChangeHandler(value);
                    }}
                    onBlur={() => {
                      dispatch(
                        FilePaymentReducerAction.updateFundTransferModeIsTouched(
                          true
                        )
                      );
                    }}
                  />
                  {fundTransferModeHasError && (
                    <p className="error"> Please Select Fund Transfer Mode</p>
                  )}
                </Grid>
              )}
              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomAutoComplete
                  variant="standard"
                  type="text"
                  placeholder="Select Payment Bank / Cash Account"
                  label="Payment Bank / Cash Account"
                  autoCompleteValues={filterValues.paymentBankArray?.map(
                    (obj) => obj.branch_name
                  )}
                  value={filterValue.paymentBankOrCash}
                  required={true}
                  onChange={(e, value) => {
                    paymentBankOrCashonChangeHandler(value);
                  }}
                  onBlur={() => {
                    dispatch(
                      FilePaymentReducerAction.updatePaymentBankOrCashIsTouched(
                        true
                      )
                    );
                  }}
                />
                {paymentBankHasError && (
                  <p className="error">
                    Please Select Payment Bank / Cash Account
                  </p>
                )}
              </Grid>

              <Grid item xs={12} sm={6} md={4} lg={3} xl={3}>
                <CustomDateField
                  label="Voucher Date"
                  variant="standard"
                  placeholder="Voucher Date"
                  value={filterValue.voucherDate}
                  disabled={
                    store.getState().filePayment.HideComponents
                      .showGridComponent
                  }
                  required={true}
                  minDate={new Date().setDate(
                    new Date().getDate() - minDateAddValue
                  )}
                  maxDate={new Date().setDate(
                    new Date().getDate() + maxDateAddValue
                  )}
                  onKeyDown={(event) => {
                    console.log(event);
                  }}
                  onChange={(value) => {
                    voucherDateOnChangeHandler(value);
                    const newDateValue = `${new Date(value).getFullYear()}/${
                      new Date(value).getMonth() + 1 > 9
                        ? new Date(value).getMonth() + 1
                        : "0" + new Date(value).getMonth() + 1
                    }/${
                      new Date(value).getDate() > 9
                        ? new Date(value).getDate()
                        : "0" + new Date(value).getDate()
                    }`;
                    const maxValue = new Date().setDate(
                      new Date().getDate() + maxDateAddValue
                    );
                    const maxDateValue = `${new Date(maxValue).getFullYear()}/${
                      new Date(maxValue).getMonth() + 1 > 9
                        ? new Date(maxValue).getMonth() + 1
                        : "0" + new Date(maxValue).getMonth() + 1
                    }/${
                      new Date(maxValue).getDate() > 9
                        ? new Date(maxValue).getDate()
                        : "0" + new Date(maxValue).getDate()
                    }`;

                    const minValue = new Date().setDate(
                      new Date().getDate() - minDateAddValue
                    );
                    const minDateValue = `${new Date(minValue).getFullYear()}/${
                      new Date(minValue).getMonth() + 1 > 9
                        ? new Date(minValue).getMonth() + 1
                        : "0" + new Date(minValue).getMonth() + 1
                    }/${
                      new Date(minValue).getDate() > 9
                        ? new Date(minValue).getDate()
                        : "0" + new Date(minValue).getDate()
                    }`;
                    const specialAccessMaxFlag = newDateValue <= maxDateValue;
                    const specialAccessMinFlag = newDateValue >= minDateValue;
                    specialAccessMaxFlag && specialAccessMinFlag
                      ? setVoucherDateError(false)
                      : setVoucherDateError(true);
                  }}
                  onBlur={() => {
                    dispatch(
                      FilePaymentReducerAction.updateVoucherDateIsTouched(true)
                    );
                  }}
                />
                {(voucherDateHasError || voucherDateError) && (
                  <p className="error"> Please Enter Valid Voucher Date</p>
                )}
              </Grid>
            </Grid>
            <Box
              sx={{
                marginTop: "8px",
                marginBottom: "4px",
                display: "flex",
                gap: "8px",
                justifyContent: "center",
              }}
            >
              <Tooltip title="Ctrl+F" placement="top">
                <Button
                  variant="contained"
                  type="submit"
                  sx={{ height: "2rem", fontWeight: "bold" }}
                  onClick={goButtonHandler}
                  ref={searchButtonRef}
                >
                  GO
                </Button>
              </Tooltip>
              <Tooltip title="Ctrl+D" placement="top">
                <Button
                  sx={{
                    color: "white",
                    backgroundColor: "black",
                    height: "2rem",
                    fontWeight: "bold",
                  }}
                  onMouseOver={({ target }) => {
                    target.style.backgroundColor = "black";
                    target.style.color = "white";
                  }}
                  variant="contained"
                  onClick={ClearButtonHandler}
                  ref={clearRef}
                >
                  Clear
                </Button>
              </Tooltip>
            </Box>
          </Box>
        </AccordianContainer>
      </Box>
      <Dialog open={DialogOpen}>
        <DialogTitle>
          <h4>Confirmation</h4>
        </DialogTitle>
        <DialogContent>
          Payment Creation process not completed. Do you want to change and
          continue?
        </DialogContent>
        <DialogActions>
          <Tooltip title="Ctrl+Q" placement="top">
            <Button onClick={onCancelButtonHandler} ref={cancelRef}>
              Cancel
            </Button>
          </Tooltip>
          <Tooltip title="Ctrl+Y" placement="top">
            <Button onClick={onOkButtonClickHandler} ref={yesRef}>
              YES
            </Button>
          </Tooltip>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default FilePaymentFilter;
